module.exports = __webpack_public_path__ + "img/dash1.80eaea7d.png";